<script setup>
import { ref } from "vue";

  const props = defineProps({
    title: {
      required: false,
      type: String,
      default: 'Title'
    }
  })

  const panel = ref([0])
</script>

<template>
  <v-expansion-panels v-model="panel" static flat color="white" rounded="xl" bg-color="white">
    <v-expansion-panel>
      <template #title>
        <h2>{{ title }}</h2>
      </template>
      <v-expansion-panel-text>
        <slot name="content" />
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>

</template>

<style scoped>
:deep(.v-expansion-panel-title:hover) {
  background-color: white !important;
}

:deep(.v-expansion-panel--active > .v-expansion-panel-title) {
  background-color: white !important;
}

:deep(.v-expansion-panel-title__overlay) {
  background-color: transparent !important;
}
</style>
